module.exports = __webpack_public_path__ + "img/black.0f65c5e9.png";